//doent return an error if the id doesnt exist, instead returns an empty function
Document.prototype.querySelectorSafe = function (selector) {
	let element = this.querySelector(selector);
	if (!element) {
		console.error('Element with selector ' + selector + ' does not exist.');
		return new Proxy({}, {
			get: function (target, property) {
				return function () { };
			}
		});
	}
	return element;
}

Document.prototype.getElementByIdSafe = function (id) {
	let element = this.getElementById(id);
	if (!element) {
		console.error('Element with id ' + id + ' does not exist.');
		return new Proxy({}, {
			get: function (target, property) {
				return function () { };
			}
		});
	}
	return element;
}

const menuToggle = document.querySelector('.toggle');
menuToggle.addEventListener('click', () => {
    menuToggle.classList.toggle('active');
});

adjustContentSpacing();

window.addEventListener("resize", () => {
    adjustContentSpacing();
});

function adjustContentSpacing()
{
    const headerHeight = document.querySelector('#header').offsetHeight;
    const mainContent = document.querySelector('#mainContent');
    const mobileMenu = document.querySelector('#mobileMenu');
    mainContent.style.paddingTop = `${headerHeight + 1 }px`;
    mobileMenu.style.marginTop = `${headerHeight + 1 }px`;
}

function sliderAutoplay(slider, duration) {
    duration = duration || 2000
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
        clearTimeout(timeout)
    }
    function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
            timeout = setTimeout(() => {
            slider.next()
        }, duration)
    }
    slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
        })
        nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
}

function sliderNavigation(slider, navClasses, dotsClasses) {
    navClasses = navClasses || [];
    dotsClasses = dotsClasses || ["d-flex", "mt-4", "pt-2", "justify-content-center"];
    let wrapper, dots, arrowLeft, arrowRight

    function removeActive() {
        slider.slides.forEach((slide) => {
            slide.classList.remove("active")
        })
    }

    function addActive(idx) {
        slider.slides[idx].classList.add("active")
    }

    function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
    }

    function removeElement(elment) {
        elment.parentNode.removeChild(elment)
    }

    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft)
            removeElement(arrowRight)
            return
        }
        // create right arrow
        arrowLeft = createDiv("arrow arrow--left")
        // add html to arrow
        arrowLeft.innerHTML = `<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893L0.292893 12.2929C-0.0976315 12.6834 -0.0976315 13.3166 0.292893 13.7071L12.2929 25.7071C12.6834 26.0976 13.3166 26.0976 13.7071 25.7071C14.0976 25.3166 14.0976 24.6834 13.7071 24.2929L2.41421 13L13.7071 1.70711C14.0976 1.31658 14.0976 0.683417 13.7071 0.292893Z" fill="#3C3B70"/></svg>`;
        // add attribute
        arrowLeft.setAttribute("role", "button")
        // add style to arrow
        arrowLeft.style.cssText = `top: 40%; left: -38px;`;
        // add class to left arrow
        arrowLeft.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowLeft.addEventListener("click", () => slider.prev())

        // create right arrow
        arrowRight = createDiv("arrow arrow--right")
        // add html to arrow
        arrowRight.innerHTML = `<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071L1.70711 25.7071C1.31658 26.0976 0.683417 26.0976 0.292893 25.7071C-0.0976311 25.3166 -0.0976311 24.6834 0.292893 24.2929L11.5858 13L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#3C3B70"/></svg>`;
        // add attribute
        arrowRight.setAttribute("role", "button")
        // add style to arrow
        arrowRight.style.cssText = `top: 40%; right: -38px;`;
        // add class to left arrow
        arrowRight.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowRight.addEventListener("click", () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
        }
        wrapper = createDiv("navigation-wrapper")
        // add class to wrapper
        wrapper.classList.add(...["position-relative"])
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
    }

    function dotMarkup(remove) {
        if (remove) {
            removeElement(dots)
            return
        }
        dots = createDiv("dots")
        //   add class to dots
        dots.classList.add(...[...dotsClasses])
        slider.track.details.slides.forEach((_e, idx) => {

            var dotParent = createDiv("dot-parent");
            dotParent.classList.add("mx-1");
            var dot = createDiv("dot")
            // add class to dot
            dot.classList.add("m-1")
            dot.classList.add("mx-2")
            // add style to dot
            dot.style.background = "var(--bs-gray-500)"
            dot.style.border = "3px solid var(--bs-gray-500)"
            dot.style.borderRadius = "50%"
            dot.style.height = "13px"
            dot.style.width = "13px"
            dot.setAttribute("role", "button") // add attribute
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dotParent.appendChild(dot);
            dots.appendChild(dotParent)
        })
        wrapper.appendChild(dots)
    }

    function updateClasses() {
        var slide = slider.track.details.rel
        slide === 0
            ? arrowLeft.classList.add("arrow--disabled")
            : arrowLeft.classList.remove("arrow--disabled")
        slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add("arrow--disabled")
            : arrowRight.classList.remove("arrow--disabled")
            Array.from(dots.children).forEach(function (dotP, idx) {
                var dot = dotP.children[0];
                if(idx === slide){
                    dot.classList.add("dot--active")
                    dot.classList.add("border-primary")
                    dot.classList.add("bg-white")
                } else {
                    dot.classList.remove("dot--active")
                    dot.classList.remove("border-primary")
                    dot.classList.remove("bg-white")
                }
            })
    }

    slider.on("created", () => {
        addActive(slider.track.details.rel)
        markup()
        updateClasses()
    })
    slider.on("optionsChanged", () => {
        markup(true)
        markup()
        updateClasses()
    })
    slider.on("slideChanged", () => {
        removeActive()
        addActive(slider.track.details.rel)
        updateClasses()
    })
    slider.on("destroyed", () => {
        markup(true)
    })
}

function sliderAdaptiveHeight(slider) {
    function updateHeight() {
        slider.container.style.height = slider.slides[slider.track.details.rel].offsetHeight + "px";
    }

    slider.on("created", updateHeight)
    slider.on("slideChanged", updateHeight)
}

console.log('test');
